import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFeedback } from '../context/FeedbackContext';
import ContentReader from './ContentReader';
import AboutModal from './AboutModal';
import { useLocale } from '../context/LocaleContext';
import styles from '../styles/footer.module.css';

const Footer: React.FC = () => {
  const { openFeedbackModal } = useFeedback();
  const { t } = useLocale();
  const location = useLocation();
  
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [version, setVersion] = useState('1.0.0');
  
  // Load version from version-info.json (always fetch fresh, never from cache)
  useEffect(() => {
    fetch('/version-info.json', { cache: 'no-store' })
      .then(res => res.json())
      .then(data => setVersion(data.version))
      .catch(() => setVersion('1.0.0')); // fallback
  }, []);

  const getPageIdentifier = () => {
    const path = location.pathname;
    if (path.includes('/step-')) {
      const stepMatch = path.match(/\/step-(\d+)/);
      return stepMatch ? `Step ${stepMatch[1]}` : path;
    }
    if (path === '/') return 'Home';
    if (path === '/saa') return 'SAA Home';
    if (path === '/saa/12-steps') return '12 Steps';
    if (path === '/discover') return 'Discover';
    if (path === '/self-assess') return 'Self Assessment';
    if (path === '/admin') return 'Admin';
    if (path === '/onboarding') return 'Onboarding';
    return path.replace('/', '').replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  const handleFeedbackClick = () => {
    openFeedbackModal(getPageIdentifier());
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerRow}>
          <button onClick={handleFeedbackClick} className={styles.footerLink}>{t('nav.footer.feedback')}</button>
          <button onClick={() => setIsAboutOpen(true)} className={styles.footerLink}>{t('nav.footer.about')}</button>
          <button onClick={() => setIsPrivacyOpen(true)} className={styles.footerLink}>{t('nav.footer.privacy')}</button>
        </div>
        <div className={styles.footerMeta}>
          <span className={styles.versionInfo}>{t('nav.footer.version', { version })}</span>
          <span className={styles.copyright}>© Recovery Commons</span>
          <span className={styles.rights}>{t('nav.footer.rights')}</span>
        </div>
      </div>

      {/* Modals */}
      <ContentReader
        isOpen={isPrivacyOpen}
        onClose={() => setIsPrivacyOpen(false)}
        filePath="/content/Recovery-Commons-Privacy.md"
        startTag=""
        endTag=""
        title={t('nav.privacy_title')}
      />
      
      <AboutModal
        isOpen={isAboutOpen}
        onClose={() => setIsAboutOpen(false)}
      />
    </footer>
  );
};

export default Footer;
